<template>
  <section class="ine-form" style="position: relative;">
    <Background />
    <ForgotPasswordForm :isLoading="isLoading" @submit-form="submitForm" />
  </section>
</template>

<script>
import Background from '@/components/forms/elements/Background.vue'
import ForgotPasswordForm from '@/components/forms/ForgotPasswordForm.vue'

export default {
  name: 'ForgotPassword',
  components: {
    Background,
    ForgotPasswordForm,
  },
  metaInfo() {
    return {
      title: 'INE - Forgot Password',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    async submitForm({ email }) {
      this.isLoading = true
      await this.$store.dispatch('auth/triggerForgotPassword', email)
      this.isLoading = false
    },
  },
}
</script>
